import { render, staticRenderFns } from "./BizOrder.vue?vue&type=template&id=c7e0e35e&scoped=true&"
import script from "./BizOrder.vue?vue&type=script&lang=js&"
export * from "./BizOrder.vue?vue&type=script&lang=js&"
import style0 from "./BizOrder.vue?vue&type=style&index=0&id=c7e0e35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e0e35e",
  null
  
)

export default component.exports